export default __webpack_public_path__ + "static/Group10618-c260956be0e787fde3ec7504604f8a78.png";